<template>
  <component :is="layout" :key="layout"></component>
</template>

<script>
import { nextTick } from 'vue'
import { clearAuthenticatedBodyShell } from './helpers/authShell';
import Guest from "./components/layouts/Guest";
import Professional from "./components/layouts/auth/Professional";
import SubscriptionOnboarding from "./components/layouts/SubscriptionOnboarding.vue";

export default {
  name: "App",
  components: {
    'guest-layout': Guest,
    'professional-layout': Professional,
    'subscription-onboarding-layout': SubscriptionOnboarding,
  },
  computed: {
    layout () {
      if (!this.$store.getters['auth/isAuth']) {
        return 'guest-layout';
      }

      return this.$route.meta.layout ?? 'guest-layout';
    }
  },
  mounted() {
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    this.tooltips = tooltipTriggerList.map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
  },
  beforeUnmount() {
    this.tooltips.forEach(tooltip => tooltip.dispose());
  },
  watch: {
    layout: {
      handler(layout) {
        if (layout === 'guest-layout') {
          clearAuthenticatedBodyShell();
        }
      },
      immediate: true,
    },
    '$route.path': {
      handler() {
        if (!this.$store.getters['auth/isAuth']) {
          return;
        }

        nextTick(() => {
          KTToggle.createInstances();
          KTSticky.createInstances();
          KTMenu.createInstances();
          KTScroll.createInstances();
          KTDrawer.createInstances();
          KTScrolltop.createInstances();
          KTDialer.createInstances();
          KTImageInput.createInstances();
          KTPasswordMeter.createInstances();
          KTSwapper.createInstances();
        });
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
@import "~bootstrap-icons/font/bootstrap-icons.css";

html,
body {
  touch-action: manipulation;
}

.btn-outline-primary:hover {
  color: #fff;
  background-color: #a21c7c;
}

.btn-check:active+.btn-outline-primary, .btn-check:checked+.btn-outline-primary, .btn-outline-primary.active, .btn-outline-primary.dropdown-toggle.show, .btn-outline-primary:active {
  background-color: #780f5a;
  border-color: #780f5a;
  color: #fff;
}

.btn-outline-primary {
  color: #780f5a;
  border-color: #780f5a;
}

.form-check-input:checked {
  background-color: #780f5a;
  border-color: #780f5a;
}

.bg-primary {
  background-color: #780f5a !important;
}

.form-control {
    border-color: #b5b5c3 !important;
}

.bg-ubbi {
  background-color: #780f5a !important;
}

.btn.btn-primary {
    background-color: #780f5a;
}

.btn-check:active+.btn.btn-primary, .btn-check:checked+.btn.btn-primary, .btn.btn-primary.active, .btn.btn-primary.show, .btn.btn-primary:active:not(.btn-active), .btn.btn-primary:focus:not(.btn-active), .btn.btn-primary:hover:not(.btn-active), .show>.btn.btn-primary {
    background-color: #440634 !important;
}

.menu-state-title-primary .menu-item.hover:not(.here)>.menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
    color: #780f5a;
}

.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
    background-color: #a21c7c;
}

.border-primary {
    border-color: #440634 !important;
}

.border-hover-primary:hover {
    border-color: #780f5a !important;
}

.bg-hover-light-primary:hover {
    background-color: rgba(120, 15, 90, 0.06) !important;
}

.nav-pills .nav-link.active {
  background-color: #780f5a;
}

.text-primary {
    color: #780f5a !important;
}

.nav-pills .nav-link {
  color: #6c757d;
}

.aside-menu .menu>.menu-item>.menu-link .menu-icon i {
    color: #a1a5b7;
}

.aside-menu .menu>.menu-item.hover:not(.here)>.menu-link:not(.disabled):not(.active):not(.here) .menu-icon i,
.aside-menu .menu>.menu-item:not(.here)>.menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
    color: #ffffff;
}

.aside {
    background-color: #780f5a;
}

.aside .aside-logo {
    background-color: #780f5a;
}

@media (min-width: 992px) {
    .aside {
        width: 92px;
    }
}

@media (min-width: 992px) {
    .aside-enabled.aside-fixed.header-fixed .header {
        left: 85px;
    }
}

@media (min-width: 992px) {
    .aside-enabled.aside-fixed .wrapper {
        padding-left: 85px;
    }
}

.badge-light-primary {
  background-color: #f3e6f0;
  color: #780f5a;
}

</style>
